export default {
  myFiles: 'Moji dokumenti',
  newDocument: 'Novi dokument',
  messages: 'Poruke',
  addresses: 'Adrese',
  newAddress: '+ Nova adresa',
  aboutUs: 'O nama',
  addArticle: 'Dodaj artikl',
  addAttribute: 'Dodaj atribut',
  addBank: 'Dodaj banku',
  addBlog: 'Dodaj vijest',
  addBrand: 'Dodaj marku',
  addCategory: 'Dodaj kategoriju',
  addCompany: 'Dodaj tvrtku',
  addCountry: 'Dodaj državu',
  addCurrency: 'Dodaj valutu',
  addCustomerBankAccount: 'Dodaj korisnički račun',
  accountDetails: 'Detalji profila',
  addExpressPost: 'Dodaj brzu poštu',
  addInterestsArea: 'Dodaj djelatnost',
  addMeasurementUnit: 'Dodaj jedinicu mjere',
  addPoll: 'Dodaj anketu',
  addProductSale: 'Dodaj akciju',
  addTab: 'Dodaj karticu',
  blog: 'Blog',
  addTown: 'Dodaj grad',
  addToCart: 'Dodaj u košaricu',
  addToCart2: 'U košaricu',
  docDate: 'Datum dok.',
  account: 'Račun',
  owes: 'Duguje',
  comment: 'Komentar',
  accountNumber: 'Broj računa',
  claims: 'Potražuje',
  paymentTerm: 'Rok plaćanja',
  bookingDateShort: 'Datum knj.',
  addUser: 'Dodaj korisnika',
  addVariation: 'Dodaj varijaciju',
  apply: 'Primijeni',
  article: 'Proizvod',
  areYouSureArticle: 'Jeste li sigurni da želite obrisati artikl {article}?',
  areYouSureAttribute: 'Jeste li sigurni da želite obrisati atribut {attribute}?',
  areYouSureAttributeArticle: 'Jeste li sigurni da želite obrisati atribut?',
  areYouSureAttributeValue: 'Jeste li sigurni da želite obrisati vrijednost atributa {attributeValue}?',
  areYouSureBank: 'Jeste li sigurni da želite obrisati banku {bank}?',
  areYouSureBlog: 'Jeste li sigurni da želite obrisati vijest {blog}?',
  areYouSureBrand: 'Jeste li sigurni da želite obrisati marku {brand}?',
  areYouSureCategory: 'Jeste li sigurni da želite obrisati kategoriju {category}?',
  areYouSureCompany: 'Jeste li sigurni da želite obrisati tvrtku {company}?',
  areYouSureCountry: 'Jeste li sigurni da želite obrisati državu {country}?',
  areYouSureCurrency: 'Jeste li sigurni da želite obrisati valutu {currency}?',
  areYouSureCustomerBankAccount: 'Jeste li sigurni da želite obrisati korisnički bankovni račun {bankAccount}?',
  areYouSureExpressPost: 'Jeste li sigurni da želite obrisati brzu poštu {post}?',
  areYouSureInterestsArea: 'Jeste li sigurni da želite obrisati djelatnost {area}?',
  areYouSureProductSale: 'Jeste li sigurni da želite obrisati akciju {productSale}?',
  areYouSureSelected: 'Jeste li sigurni da želite obrisati odabrane zapise?',
  areYouSureTab: 'Jeste li sigurni da želite obrisati karticu {tab}?',
  areYouSureTown: 'Jeste li sigurni da želite obrisati grad {town}?',
  areYouSureUser: 'Jeste li sigurni da želite obrisati korisnika {user}?',
  areYouSureCancelOrder: 'Jeste li sigurni da želite otkazati narudžbu?',
  areYouSureApproveOrder: 'Jeste li sigurni da želite odobriti narudžbu?',
  articleDetails: 'Detalji artikla',
  articleDetailsInfo: 'Unesite detalje artikla',
  articles: 'Artikli',
  attributes: 'Atributi',
  banks: 'Banke',
  blogs: 'Vijesti',
  brands: 'Marke',
  brand: 'Marka',
  service: 'Servis',
  cancel: 'Otkaži',
  newRequest: 'Novi zahtjev',
  contactPerson: 'Kontakt osoba',
  categories: 'Kategorije',
  category: 'Kategorija',
  serialNumber: 'Serijski broj',
  productCode: 'Šifra proizvoda',
  checkout: 'Naplata',
  download: 'Preuzmi',
  actions: 'Radnje',
  sales: 'Akcije',
  folderIsEmpty: 'Vaš direktorij s dokumentima je prazan',
  physicalPersons: 'Fizičke osobe',
  goToCheckout: 'Idi na naplatu',
  choose: 'Odaberite',
  chooseOptions: 'Odaberite opcije',
  contact: 'Kontakt',
  onlineShopping: 'Online kupovina',
  ord: 'Rbr',
  myAccount2: 'Moj račun',
  myArticles: 'Moji proizvodi',
  followUsOnSocialMedia: 'Pratite nas na društvenim mrežama',
  deliveryAndPayment: 'Dostava i plaćanje',
  complaintsAndReturns: 'Reklamacije i povrati',
  securityAndPrivacy: 'Sigurnost i privatnost',
  termsOfService: 'Uvjeti korištenja i kupnje',
  youNeedHelp: 'Trebate pomoć?',
  from: 'Od',
  to: 'Do',
  title: 'Naslov',
  markAllAsRead: 'Označi sve kao pročitano',
  faq: 'Česta pitanja',
  howToRegister: 'Kako se registrirati?',
  shoppingHelp: 'Pomoć pri kupnji',
  bonusProgramRules: 'Pravila bonus programa',
  comingSoon: 'Uskoro',
  companies: 'Tvrtke',
  countries: 'Države',
  countryDetails: 'Detalji države',
  countryDetailsInfo: 'Unesite detalje države',
  viewFinances: 'Pogledaj financije',
  coupons: 'Kuponi',
  currencies: 'Valute',
  customerBankAccounts: 'Korisnički računi',
  profileDashboard: 'Nadzorna ploča',
  defaultAddress: 'Sljedeće adrese će se prema zadanim postavkama koristiti na stranici za naplatu.',
  delete: 'Izbriši',
  currentDebt: 'Trenutno zaduženje',
  deleteArticle: 'Izbriši artikl',
  paymentTerms: 'Uvjeti plaćanja',
  deleteAttribute: 'Izbriši atribut',
  debtOutsideCurrency: 'Dug izvan valute',
  deleteBank: 'Izbriši banku',
  deleteBlog: 'Izbriši vijest',
  edit: 'Uredi',
  approvedDebt: 'Odobreno zaduženje',
  deleteBrand: 'Izbriši marku',
  deleteCategory: 'Izbriši kategoriju',
  notSetAnyAddressYet: 'Još niste postavili nijednu adresu.',
  deleteCompany: 'Izbriši tvrtku',
  deleteCountry: 'Izbriši državu',
  deleteCurrency: 'Izbriši valutu',
  deleteCustomerBankAccount: 'Izbriši korisnički bankovni račun',
  deleteExpressPost: 'Izbriši brzu poštu',
  deleteInterestsArea: 'Izbriši djelatnost',
  deleteProductSale: 'Izbriši akciju',
  deleteSelected: 'Izbriši odabrano',
  deleteTab: 'Izbriši karticu',
  deleteTown: 'Izbriši grad',
  deleteUser: 'Izbriši korisnika',
  deleteVariationImage: 'Jeste li sigurni da želite izbrisati sliku varijacije?',
  details: 'Detalji',
  detailsInfo: 'Unesite detalje',
  editArticle: 'Ažuriraj artikl',
  editAttribute: 'Ažuriraj atribut',
  editBank: 'Ažuriraj banku',
  editBlog: 'Ažuriraj vijest',
  editBrand: 'Ažuriraj marku',
  editCategory: 'Ažuriraj kategoriju',
  editCompany: 'Ažuriraj tvrtku',
  editCountry: 'Ažuriraj državu',
  editCurrency: 'Ažuriraj valutu',
  editCustomerBankAccount: 'Ažuriraj korisnički račun',
  editExpressPost: 'Ažuriraj brzu poštu',
  editInterestArea: 'Ažuriraj djelatnost',
  editPoll: 'Ažuriraj anketu',
  editProductSale: 'Ažuriraj akciju',
  editTab: 'Ažuriraj karticu',
  editTown: 'Ažuriraj grad',
  editUser: 'Ažuriraj korisnika',
  expressPosts: 'Brze pošte',
  forgotPassword: 'Zaboravljena lozinka',
  greetings: 'Pozdrav',
  homePageTitle: 'Početna stranica',
  highlightedCategories: 'Izdvojeno',
  import: 'Uvezi',
  importArticles: 'Uvezi artikle',
  interestsAreas: 'Djelatnosti',
  cancel2: 'ODUSTANI',
  cancel3: 'Odustani',
  login: 'Prijava',
  logIn: 'Prijavi se',
  logout: 'Odjava',
  measurementUnits: 'Jedinice mjere',
  myAccount: 'Moj profil',
  delete2: 'IZBRIŠI',
  myProfile: 'Profil',
  news: 'Vijesti',
  newArticles: 'Novi proizvodi',
  no: 'Ne',
  attention: 'Pažnja',
  warning: 'Upozorenje',
  areYouSureYouWantToDeleteAcc: 'Jeste li sigurni da želite izbrisati svoj račun? Unesite lozinku kako biste izbrisali račun.',
  areYouSureYouWantToDeleteAddress: 'Jeste li sigurni da želite ukloniti odabranu adresu?',
  noItemSelected: 'Nema odabranih zapisa',
  noRecords: 'Nema rezultata prema traženim parametrima',
  notFound: 'Tražena stranica nije pronađena',
  orderArticles: 'Artikli u košarici',
  orders: 'Narudžbe',
  polls: 'Ankete',
  priceRange: 'Cjenovni raspon',
  productSales: 'Akcije',
  recentlyViewdItems: 'Nedavno ste pregledavali',
  register: 'Registracija',
  resetFilters: 'Poništi filtere',
  rma: 'Prijavljene nepravilnosti (RMA)',
  rmaForm: 'Reklamacije',
  save: 'Spremi',
  saveArticle: 'Spremi artikl',
  saveCategory: 'Spremi kategoriju',
  saveCountry: 'Spremi državu',
  search: 'Pretraživanje',
  find: 'Unesite najmanje 3 znaka...',
  selectAction: 'Odaberite akciju',
  shoppingCart: 'Košarica',
  tabs: 'Kartice',
  terms: 'Uvjeti korištenja',
  townDetails: 'Detalji grada',
  townDetailsInfo: 'Unesite detalje grada',
  towns: 'Gradovi',
  total: 'Ukupno',
  amount: 'Iznos',
  topBrands: 'Top Brendovi',
  userProfile: 'Korisnički profil',
  users: 'Korisnici',
  userArticles: 'Proizvodi odabrani za vas',
  viewAll: 'Prikaži sve',
  viewAllFrom: 'Prikaži sve iz',
  addToCartSuccessMessage: 'Upravo ste dodali artikl u <br/> košaricu: ',
  continueShopping: 'Nastavi kupovinu',
  clearShoppingCart: 'Isprazni košaricu',
  updateShoppingCart: 'Ažuriraj košaricu',
  goToShoppingCart: 'Idi u košaricu',
  wishlist: 'Lista želja',
  addToWishlist: 'Dodaj na listu želja',
  yes: 'Da',
  reviews: 'Recenzija',
  tabReviews: 'Recenzije',
  writeReview: 'Unesite svoju recenziju',
  submitReview: 'Pošalji recenziju',
  anonymous: 'Anonimno',
  linkedArticles: 'Povezani proizvodi',
  quickPreview: 'Brzi pregled',
  loginRegisterTitle: 'Prijava / Kreiranje računa',
  loginTitle: 'Prijava',
  loginSubTitle: 'Ako imate korisnički račun, prijavite se.',
  loginButton: 'PRIJAVA',
  registerTitle: 'Zatražite korisnički račun',
  registerSubTitle: 'Ispunite tražene podatke i naš tim će vas kontaktirati u najkraćem roku te izraditi korisnički račun. Hvala!',
  chooseCountry: 'Odaberite državu',
  chooseTown: 'Odaberite grad',
  registerSectionLoginDataTitle: 'Podaci za prijavu',
  acceptTerms: 'Prihvaćam uvjete korištenja',
  registerSubmit: 'Zatraži račun',
  repeatOrder: 'Ponovi narudžbu',
  close: 'Zatvori',
  defaultSort: 'Zadano sortiranje',
  sortByRating: 'Sortiraj po ocjeni',
  sortByDateOldest: 'Sortiraj po datumu: od najstarijeg',
  sortByDateNewest: 'Sortiraj po datumu: od najnovijeg',
  sortByPriceLow: 'Sortiraj po cijeni: od niže prema višoj',
  sortByPriceHigh: 'Sortiraj po cijeni: od više prema nižoj',
  pagingResults: 'Prikazuje se {fromResults} - {toResults} od ukupno {totalItems} rezultata',
  showMore: 'Prikaži više',
  productIsAvalible: 'Proizvod je dostupan',
  productIsAvalibleToOrder: 'Proizvod je dostupan po narudžbi',
  deliveryTimeDays: 'Vrijeme isporuke je {days} dana od narudžbe',
  itemIsAvalibleContactRepresentative: 'Artikl je dostupan po narudžbi. Molimo kontaktirajte svog prodajnog predstavnika.',
  availableOnRequest: 'Dostupno na upit',
  requestPresentation: 'Zatraži prezentaciju',
  howDoYouRateThisProduct: 'Kako ocjenjujete ovaj proizvod?',
  administrator: 'Administrator',
  passwordRecovery: 'Obnova lozinke',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Unesite svoju e-mail adresu i poslat ćemo vam upute za resetiranje!',
  reset: 'Resetiraj',
  remembered: 'Zapamćeno',
  finances: 'Financije',
  allRightsReserved: 'Sva prava pridržana',
  updateAddress: 'Ažuriraj adresu',
  state: 'Država',
  chooseState: 'Odaberite državu',
  listIsEmpty: 'Lista je prazna',
  noResultsAccordingToTheGivenParameters: 'Nema rezultata prema zadanim parametrima',
  termsOfUseIsMandatory: 'Polje "Uvjeti korištenja" je obavezno',
  resetPassword: 'Resetiranje lozinke',
  accVerificationInProgress: 'Verifikacija računa u tijeku',
  accVerification: 'Verifikacija računa',
  verificationLinkHasExpired: 'Verifikacijska poveznica je istekla. Molimo kontaktirajte naše administratore: support@eurosan.ba ili +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'Upravo ste dodali artikl u košaricu:',
  manufacturer: 'Proizvođač',
  productName: 'Naziv proizvoda',
  shoppingCarts: 'Košarice',
  preview: 'Pregled',
  documentName: 'Naziv dokumenta',
  status: 'Status',
  orderNumber: 'Broj narudžbe',
  orderer: 'Naručitelj',
  date: 'Datum',
  document: 'Dokument',
  delivery: 'Dostava',
  deliverTo: 'Dostaviti na',
  discount: 'Popust',
  savingsByUsingPromoCode: 'Ušteda korištenjem promo koda',
  itemAddedToCart: 'Artikl je dodan u košaricu.',
  articlesOnSale: 'Proizvodi na akciji',
  controlPanel: 'Kontrolna ploča',
  tags: 'Oznake',
  totalAmountWithDelivery: 'Ukupan iznos s dostavom',
  youHaveNotPlacedAnorderYet: 'Još niste napravili narudžbu',
  quantity: 'Količina',
  amountWithoutVat: 'Iznos bez PDV-a',
  vatAmount: 'Iznos PDV-a',
  orderNo: 'Narudžba br.',
  days: 'dana',
  time: 'Vrijeme',
  quantity2: 'KOLIČINA',
  rejectOrd: 'Odbij narudžbu',
  approveOrd: 'Odobri narudžbu',
  wishListIsEmpty: 'Lista želja je prazna',
  sale: 'AKCIJA',
  totalWithoutTax: 'Ukupno bez poreza',
  sendRequest: 'POŠALJI ZAHTJEV',
  promoCode: 'Promo kod',
  send: 'Pošalji',
  registrationCode: 'Registracijski kod',
  created: 'Kreirano',
  giftCard: 'Poklon bon',
  changePassword: 'Promjena lozinke',
  emailAddress: 'E-mail adresa',
  oldPassword: 'Stara lozinka',
  deleteUserAcc: 'IZBRIŠI KORISNIČKI RAČUN',
  permanentlyDeletedAcc: 'Korisnički račun će biti trajno izbrisan',
  confirmNewPassword: 'Potvrdite novu lozinku',
  passwordConfirmation: 'Potvrda lozinke',
  newPassword: 'Nova lozinka',
  newPassLeaveBlank: 'Nova lozinka (ostavite prazno ako je ne želite mijenjati)',
  currentPassLeaveBlank: 'Trenutna lozinka (ostavite prazno ako je ne želite mijenjati)',
  areasOfInterest: 'Područja interesa',
  chooseAreaOfInterest: 'Odaberite područja interesa',
  totalTax: 'Ukupno poreza',
  price: 'Cijena',
  price2: 'CIJENA',
  newAddress2: 'Nova adresa',
  show: 'Prikaži',
  stock: 'Stanje',
  yourTotalDebtIs: 'Vaš ukupni dug iznosi',
  isInStock: 'Dostupno na skladištu',
  print: 'Ispis',
  signUpForTheNewsletter: 'Prijavite se na newsletter',
  latestInformations: 'Primajte najnovije informacije o događajima, rasprodajama i ponudama.',
  subscribe: 'Pretplatite se',
  aboutEurosanGroup: 'O Eurosan grupaciji',
  responsibleBusiness: 'Društveno odgovorno poslovanje',
  noDataToAccordingData: 'Nema podataka prema traženim parametrima',
  jobAtEurosan: 'Zaposlenje u Eurosanu',
  vpc: 'VPC',
  products: 'proizvoda',
  phoneNumber: 'Broj telefona',
  tax: 'PDV',
  defaultAddress2: 'Zadana adresa',
  totalWithVat: 'Ukupno s PDV-om',
  totalWithoutVat2: 'Ukupno bez PDV-a',
  summary: 'Sažetak',
  warranty: 'Jamstvo',
  zipCode: 'Poštanski broj',
  indeterminate: 'Neodređeno',
  description: 'Opis',
  forms: {
    notValid: 'Uneseni podaci nisu valjani!',
    labels: {
      username: 'Korisničko ime',
      abbreviation: 'Skraćenica',
      address: 'Adresa',
      email: 'E-mail adresa',
      articleType: 'Vrsta artikla',
      availableValues: 'Dostupne vrijednosti',
      bank: 'Banka',
      bankAccount: 'Bankovni račun',
      brand: 'Brend',
      catalogNumber: 'Kataloški broj',
      category: 'Kategorija',
      code: 'Šifra',
      company: 'Tvrtka',
      content: 'Sadržaj',
      country: 'Država',
      countryName: 'Naziv države',
      defaultPrice: 'Zadana cijena',
      description: 'Opis',
      fax: 'Faks',
      interestsArea: 'Područje djelatnosti',
      isVisibleOnWeb: 'Vidljivo na webu',
      mpc: 'Maloprodajna cijena',
      name: 'Naziv',
      nc: 'Nabavna cijena',
      nettoWeight: 'Neto težina',
      officeNumber: 'Broj ureda',
      phone: 'Telefon',
      password: 'Lozinka',
      confirmPassword: 'Ponovite lozinku',
      shortDescription: 'Kratki opis',
      symbol: 'Simbol',
      taxGroup: 'Porezna grupa',
      title: 'Naziv',
      town: 'Grad',
      townName: 'Naziv grada',
      unit: 'Jedinica',
      unitOfMeasure: 'Jedinica mjere',
      videoUrl: 'Video poveznica',
      vpc: 'Veleprodajna cijena',
      firstName: 'Ime',
      lastName: 'Prezime',
    },
    errors: {
      default: 'Došlo je do pogreške prilikom provjere valjanosti.',
      email: 'Polje {field} nije valjana e-mail adresa.',
      integer: 'Polje {field} mora biti broj.',
      minLength: 'Minimalno {count} znakova.',
      required: 'Polje {field} je obavezno.',
      sameAs: 'Polja {field} i {field2} se ne podudaraju.',
      url: 'Polje {field} nije valjana URL adresa.',
    },
  },
  tables: {
    email: 'E-mail',
    firstLastName: 'Ime i prezime',
    id: 'ID',
    name: 'Naziv',
    phone: 'Telefon',
    town: 'Grad',
    username: 'Korisničko ime',
  },
};
